export default function WhyDifferent() {
  const advantages = [
    { icon: 'ri-phone-line', text: 'До обучения анализирую реальные звонки', desc: 'Не теоретические предположения, а фактические записи разговоров ваших менеджеров.' },
    { icon: 'ri-user-star-line', text: 'Сам регулярно продаю через холодные звонки', desc: 'Не учу тому, что не делаю. Все техники проверены на практике.' },
    { icon: 'ri-file-list-3-line', text: 'Используем реальные разговоры сотрудников', desc: 'Никаких абстрактных примеров — только ваши клиенты и ваши сценарии.' },
    { icon: 'ri-lightbulb-line', text: 'Разбираем сложные кейсы компании', desc: 'Работаем с ситуациями, в которых менеджеры реально теряют клиентов.' },
    { icon: 'ri-user-voice-line', text: 'Практикуемся на реальных клиентах', desc: 'Отработка звонков на настоящих контактах из вашей базы.' },
    { icon: 'ri-hand-heart-line', text: 'Сопровождаю внедрение после тренинга', desc: 'Не брошу после обучения: разборы, корректировка, поддержка в чате.' },
    { icon: 'ri-book-open-line', text: 'Помогаю создавать регламенты и Книгу продаж', desc: 'Систематизируем подход, чтобы результаты сохранялись без моего участия.' },
  ];

  return (
    <section id="why-different" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему мои программы отличаются
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            То, что говорят клиенты после обучения — это не комплименты, а результат системного подхода к каждому проекту.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto mb-12">
          {advantages.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all duration-300 flex items-start gap-4">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900 mb-1 flex items-center gap-2">
                  <i className="ri-check-line text-teal-600 text-sm"></i>
                  {item.text}
                </h3>
                <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-teal-600 rounded-2xl p-8 md:p-10 text-white text-center">
            <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-quote-text text-3xl text-white"></i>
            </div>
            <p className="text-xl md:text-2xl font-bold leading-relaxed">
              Я не обучаю абстрактным скриптам. Мы вместе строим систему телефонных продаж, которая подходит именно вашей компании.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}